import React from 'react';
import { INK } from '../styles';

interface Props {
  children: React.ReactNode;
}

export default function SectionLabel({ children }: Props) {
  return (
    <div style={{
      fontSize: 13,
      fontWeight: 700,
      color: INK,
      margin: '22px 0 10px',
      textTransform: 'uppercase',
      letterSpacing: '0.6px',
      borderBottom: '1px solid ' + INK,
      paddingBottom: 4,
    }}>
      {children}
    </div>
  );
}